import React from 'react'
import PropTypes from 'prop-types'
import AdminPanelSettings from '@mui/icons-material/AdminPanelSettings'

const AdminPanelSettingsIcon = ({ height, width, ...more }) => {
	
	return (
		<AdminPanelSettings
			height={height}
			width={width}
			{...more}
		/>
	)
}

AdminPanelSettingsIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default AdminPanelSettingsIcon
